<div *ngIf=" !isHandset else mobileTemplate ">
  <div #filterBox class="filterBox" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275" [style.bottom]="isOffScreen ?  '0' : ''">
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Source / Call Number</h4>
    <app-source-call-no-filter #sourceCallNoCmp
    [sourceData]="luSources"
    [callNumberData]="callNumberData"
    [activeFilter]="activeFilter"
    (changeSourceSelection)="sourceChanged.emit($event)"
    (setCallNumberSelection)="callNumberChanged.emit($event)"
    (levelOfSpecificity)="levelOfSpecificity.emit($event)"
    (userSelectionReady)="done($event)">
    </app-source-call-no-filter>
    <hr>
    <app-slant-button btnColor="blue" [linkMode]="true" id="closeButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)">Close</app-slant-button>
    <app-slant-button btnColor="gray" [linkMode]="true" [disabled]="!activeFilters.length" tooltip="Clear the source / call # filter and close this box" id="cancelButton" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Filter</app-slant-button>
    <label class="text-muted" *ngIf="activeFilters.length">
      Filter applied
    </label>
  </div>
</div>

<ng-template #mobileTemplate>

  <div #filterBox class="filterBox mobile" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275" [style.bottom]="isOffScreen ?  '0' : ''">
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Source / Call Number</h4>
    <app-source-call-no-filter #sourceCallNoCmp
    [sourceData]="luSources"
    [callNumberData]="callNumberData"
    [activeFilter]="activeFilter"
    (changeSourceSelection)="sourceChanged.emit($event)"
    (setCallNumberSelection)="callNumberChanged.emit($event)"
    (levelOfSpecificity)="levelOfSpecificity.emit($event)"
    (userSelectionReady)="done($event)">
    </app-source-call-no-filter>
    <hr>
    <app-slant-button btnColor="blue" [linkMode]="true" id="closeButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)">Close</app-slant-button>
    <app-slant-button btnColor="gray" [linkMode]="true" [disabled]="!activeFilters.length" tooltip="Clear the source / call # filter and close this box" id="cancelButton" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Filter</app-slant-button>
    <label class="text-muted" *ngIf="activeFilters.length">
      Filter applied
    </label>
  </div>

</ng-template>